// src/pages/campaign/BodyAnalysisLanding.jsx

import { motion } from "framer-motion";
import CountUp from "react-countup";
import { Activity, ChevronLeft, ShieldCheck, Sparkles, Smartphone, Zap, ChevronRight } from "lucide-react";
import AiBodyScanner from "../../component/AiBodyScanner";
import { useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";

export default function BodyAnalysisLanding() {
      const navigate = useNavigate();

  const startWizard = () => {
  navigate("/body-analysis/intro");
  };

const API_URL = process.env.REACT_APP_API_URL || "https://api.mogym.ir";

const [counter, setCounter] = useState(1247);

useEffect(() => {
  const loadCounter = async () => {
    try {
      const res = await fetch(`${API_URL}/api/campaign/body-analysis/count`);
      const data = await res.json();

      if (res.ok && data?.count != null) {
        setCounter(data.count);
      }
    } catch {
      // fallback همان عدد پیش‌فرض بماند
    }
  };

  loadCounter();
}, []);

  return (
    <main dir="rtl" className="font-vazir min-h-screen overflow-hidden bg-[#030712] text-white">
      <section className="relative min-h-screen px-4 pt-5 pb-6">
        <div className="absolute inset-0 bg-[radial-gradient(circle_at_50%_0%,rgba(16,185,129,.32),transparent_34%),radial-gradient(circle_at_0%_80%,rgba(37,99,235,.26),transparent_38%),radial-gradient(circle_at_100%_60%,rgba(34,211,238,.18),transparent_30%)]" />
        <div className="absolute inset-0 opacity-[.18] bg-[linear-gradient(rgba(255,255,255,.08)_1px,transparent_1px),linear-gradient(90deg,rgba(255,255,255,.08)_1px,transparent_1px)] bg-[size:34px_34px]" />
        <div className="absolute inset-0 bg-gradient-to-b from-transparent via-[#030712]/30 to-[#030712]" />

        <div className="relative z-10 mx-auto flex min-h-[calc(100vh-44px)] max-w-md flex-col">
          <header className="flex items-center justify-between">
            <img src="/logo.png" alt="MOGYM" className="h-11 w-auto" />
  <div className="
    rounded-full
    bg-emerald-400/10
    border
    border-emerald-400/20
    px-2
    py-1
    text-[10px]
    text-emerald-200
  ">
   موجیم، هوش مصنوعی تناسب اندام
  </div>
            {/* <a
              href="/app"
              className="flex items-center gap-1 rounded-full border border-white/10 bg-white/8 px-3 py-2 text-xs text-white/80 shadow-lg backdrop-blur-2xl"
            >
              <Smartphone size={14} />
              اپلیکیشن
            </a> */}
            
          </header>

          <motion.div
            initial={{ opacity: 0, y: 14 }}
            animate={{ opacity: 1, y: 0 }}
            className="mt-5 flex items-center justify-center gap-2 rounded-full border border-emerald-400/25 bg-emerald-400/10 px-4 py-2 text-center text-xs text-emerald-100 shadow-[0_0_35px_rgba(16,185,129,.18)] backdrop-blur-2xl"
          >
            <Sparkles size={14} />
            <span>
              تا الان{" "}
              <b className="text-white">
          <CountUp end={counter} duration={2} separator="," />
              </b>{" "}
              نفر تحلیل بدن خودشون رو گرفتن
            </span>
          </motion.div>

          <div className="mt-5">
            <AiBodyScanner />
          </div>

          <motion.div
            initial={{ opacity: 0, y: 18 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: 0.15 }}
            className="mt-5 text-center"
          >
            <h1 className="text-[28px] font-black leading-[1.18] tracking-[-.04em]">
              شاید دلیل نتیجه نگرفتنت
              <span className="mt-1 block bg-gradient-to-l from-emerald-300 via-cyan-300 to-blue-400 bg-clip-text text-transparent drop-shadow">
                خودت نباشی...
              </span>
            </h1>

            <p className="mx-auto mt-4 max-w-sm text-[13px] leading-7 text-white/68">
               موجیم برنامه‌ای رو نشونت میده که واقعا برای تو طراحی شده
            </p>
          </motion.div>

          {/* <div className="mt-5 grid grid-cols-3 gap-2">
            <MiniTrust icon={<Activity size={15} />} text="تحلیل اختصاصی" />
            <MiniTrust icon={<ShieldCheck size={15} />} text="اصلاح ۲۴ ساعت" />
            <MiniTrust icon={<Zap size={15} />} text="بدون پرداخت اولیه" />
          </div> */}

          <motion.button
            whileTap={{ scale: 0.96 }}
            onClick={startWizard}
            className="mt-6 flex h-16 w-full items-center justify-center gap-2 rounded-3xl bg-gradient-to-r from-emerald-300 via-green-400 to-cyan-400 text-[15px] font-black text-[#03130b] shadow-[0_0_80px_rgba(52,211,153,.55)]"
          >
                        <ChevronRight size={20} />
            شروع تحلیل رایگان بدن من
          </motion.button>

          <p className="mt-3 text-center text-[11px] text-white/45">
            کمتر از ۲ دقیقه زمان می‌ بره
          </p>
        </div>
      </section>
    </main>
  );
}

function MiniTrust({ icon, text }) {
  return (
    <div className="rounded-2xl border border-white/10 bg-white/[.06] px-2 py-3 text-center shadow-xl backdrop-blur-2xl">
      <div className="mx-auto mb-1 grid h-8 w-8 place-items-center rounded-xl bg-emerald-400/10 text-emerald-300">
        {icon}
      </div>
      <div className="text-[10px] leading-4 text-white/72">{text}</div>
    </div>
  );
}